import { render, staticRenderFns } from "./NoBottomNav.vue?vue&type=template&id=5663ccd2"
import script from "./NoBottomNav.vue?vue&type=script&lang=js"
export * from "./NoBottomNav.vue?vue&type=script&lang=js"
import style0 from "./NoBottomNav.vue?vue&type=style&index=0&id=5663ccd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VMain,VToolbarTitle})
